import { render, staticRenderFns } from "./add_feedback.vue?vue&type=template&id=a7e66444&scoped=true&"
import script from "./add_feedback.vue?vue&type=script&lang=js&"
export * from "./add_feedback.vue?vue&type=script&lang=js&"
import style0 from "./add_feedback.vue?vue&type=style&index=0&id=a7e66444&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e66444",
  null
  
)

export default component.exports